// extracted by mini-css-extract-plugin
module.exports = {"showMenu":"AdminPermission_showMenu__LGTQ1","hideMenu":"AdminPermission_hideMenu__Mycy-"};